// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import ProjectsPage from './ProjectsPage';
import TasksPage from './TasksPage';
import MembersPage from './MembersPage';

export default function DomainsRoutes() {
  return (
    <Routes>
      <Route path="projects" element={<ProjectsPage />} />
      <Route path="tasks" element={<TasksPage />} />
      <Route path="members" element={<MembersPage />} />
    </Routes>
  );
}
